import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  InitiateAuthCommandInput,
  NotAuthorizedException,
} from "@aws-sdk/client-cognito-identity-provider";
import { InvalidTokenError, jwtDecode, JwtPayload } from "jwt-decode";
const client = new CognitoIdentityProviderClient({ region: "ap-northeast-1" });
// 日付を計算
export const calcUtcDatetime = (): string => {
  // UTC時刻の取得
  const utcDate = new Date();
  const year = String(utcDate.getUTCFullYear());
  const month = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
  const date = String(utcDate.getUTCDate()).padStart(2, "0");
  const hour = String(utcDate.getUTCHours()).padStart(2, "0");
  const minute = String(utcDate.getUTCMinutes()).padStart(2, "0");
  const second = String(utcDate.getUTCSeconds()).padStart(2, "0");

  return `${year}${month}${date}${hour}${minute}${second}`;
};

export const calcCurrentDatetime = (): string => {
  // 日付を表示する変数群
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = formatDatetime(currentDate.getMonth() + 1);
  const date = formatDatetime(currentDate.getDate());
  const hour = formatDatetime(currentDate.getHours());
  const minute = formatDatetime(currentDate.getMinutes());
  const second = formatDatetime(currentDate.getSeconds());
  return `${year}${month}${date}${hour}${minute}${second}`;
};

// 日付の表示調整
const formatDatetime = (val: number): string => {
  return ("0" + val).slice(-2);
};

// トークンを取得する関数
export const getAuthToken = async () => {
  try {
    let isNeedUpdateToken = false;
    const userpool_client_id =
      process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? "";
    // セッション情報取得
    const idToken =
      localStorage.getItem(
        `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.idToken`
      ) || "";
    const decodeIdToken = jwtDecode<JwtPayload>(idToken);
    const refreshToken =
      localStorage.getItem(
        `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.refreshToken`
      ) || "";
    if (decodeIdToken) {
      const exp = decodeIdToken.exp;
      if (!exp) {
        //idTokenの期限が設定されてない
        console.log("token exp is not configured");
        isNeedUpdateToken = true;
      } else if (exp < Date.now() / 1000) {
        //idTokenの期限切れ
        console.log("token is expired");
        isNeedUpdateToken = true;
      }
    } else {
      //idTokenが存在しない
      console.log("token is not configured");
      isNeedUpdateToken = true;
    }
    //トークンの更新が必要
    if (isNeedUpdateToken) {
      const params = {
        AuthFlow: "REFRESH_TOKEN_AUTH",
        ClientId: userpool_client_id,
        AuthParameters: {
          REFRESH_TOKEN: refreshToken,
        },
      } as InitiateAuthCommandInput;
      const command = new InitiateAuthCommand(params);
      const response = await client.send(command);
      const newIdToken = response.AuthenticationResult?.IdToken;
      const newAccessToken = response.AuthenticationResult?.AccessToken;

      if (newIdToken && newAccessToken) {
        //新しいトークンを保存
        //accessToken
        localStorage.setItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.accessToken`,
          newAccessToken
        );

        //id_token
        localStorage.setItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.idToken`,
          newIdToken
        );
        return newIdToken;
      } else {
        // トークン更新が不可能ならログイン画面へ
        console.log("session is expired...");
        throw new Error("Expired token");
      }
    }
    return idToken;
  } catch (err) {
    console.log("[getAuthToken]err: " + err);
    if (err instanceof NotAuthorizedException) {
      throw new Error("Expired token");
    } else if (err instanceof InvalidTokenError) {
      //トークンが無効な形式でデコードできなかった
      throw new Error("Invalid token");
    }
    throw err;
  }
};
